// websocket 通信相关
// import SockJS from 'sockjs-client';
// import Stomp from 'stomp';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import URI from '@/assets/js/URI'

let env = 'development'
if (process && process.env && process.env.NODE_ENV) {
  env = process.env.NODE_ENV
}
export default {
  data () {
    return {
      socketTimer: null,
      stompClient: null,
      stompClientByUpload: {},
      socketTimerByUpload: {}
    }
  },
  beforeDestroy () {
    // 页面离开时断开连接,清除定时器
    this.disconnect()
  },
  computed: {
    // ws 订阅消息的地址
    urlSubscribe () {
      return URI.WS.subscribe.share + this.user.gldUserId
    }// ,
    // ws 发送消息的地址
    // urlSendMessage() {
    //   return URI.WS.sendMessage.share + this.user.gldUserId;
    // }
  },
  mounted () {
    // window.showLog = true; // 设置showLog 将会在控制台 打印 Stomp 请求/响应 记录
    // setTimeout(() => {
    //   this.initWebSocket()
    // }, 100)
  },
  methods: {
    // 2.1 初始化 websocket
    initWebSocket () {
      if (this.stompClient) return
      this.connection()
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.socketTimer = setInterval(() => {
        try {
          this.stompClient.send('test')
        } catch (err) {
          console.log('断线了: ' + err)
          this.connection()
        }
      }, 5000)
    },
    // 创建上传备案项目链接
    connectionUpload ({projectId, projectNumber, projectName}) {
      const urlCreateConnect = URI.WS.base[env] // 建立连接的地址
      const socket = new SockJS(urlCreateConnect)
      this.stompClientByUpload[projectId] = Stomp.over(socket)
      const headers = {
        clientType: 'upload',
        gldUserId: this.user.gldUserId,
        projectId,
        projectNumber,
        projectName
      }
      this.stompClientByUpload[projectId].connect(headers, (frame) => {})
      this.socketTimerByUpload[projectId] = setInterval(() => {
        try {
          this.stompClientByUpload[projectId].send('test connection upload')
        } catch (err) {
          console.log('connectionUpload断线了: ' + err)
          // this.connectionUpload(projectId)
        }
      }, 5000)
    },
    // 断开连接
    disconnectUpload (projectId) {
      if (this.socketTimerByUpload[projectId]) {
        clearInterval(this.socketTimerByUpload[projectId])
        this.socketTimerByUpload[projectId] = null
      }
      if (this.stompClientByUpload[projectId]) {
        try {
          this.stompClientByUpload[projectId].disconnect()
          this.stompClientByUpload[projectId] = null
        } catch (e) {
          console.log(e)
        }
      }
    },
    // 2.2 创建链接
    connection () {
      const urlCreateConnect = URI.WS.base[env] // 建立连接的地址
      const urlSubscribe = this.urlSubscribe // 订阅消息的地址
      // const urlSendMessage = this.urlSendMessage; // 发送消息的地址
      // console.log(urlCreateConnect);
      // console.log(urlSubscribe);
      const socket = new SockJS(urlCreateConnect)
      // 获取 STOMP 子协议的客户端对象
      this.stompClient = Stomp.over(socket)
      // 拦截输出的一大堆垃圾信息
      // this.stompClient.debug = function (str) {
      //   console.log(str);
      // };
      // 关闭控制台打印 Stomp 请求/响应 记录
      // if (process.env.NODE_ENV !== 'development') {
      //   this.stompClient.debug = null;
      // }
      const headers = {
        clientType: 'web',
        gldUserId: this.user.gldUserId
      }
      if (!urlSubscribe) return
      // console.log('----=', headers);
      this.stompClient.connect(headers, (frame) => {
        // console.log(URI[type].wsSubscribe + this.jobToken)
        this.stompClient.subscribe(urlSubscribe, (response) => {
          // console.log(response);
          try {
            const message = JSON.parse(response.body)
            this.receivedMessage(message)
          } catch (e) {
            console.log(e)
          }
        })
        // if (!urlSendMessage) return;
        // setTimeout(() => {
        //   const wsSendMessage = this.wsSendMessage || '';
        //   wsSendMessage && this.stompClient.send(urlSendMessage, headers, JSON.stringify(wsSendMessage));
        // }, 500);
      }, (error) => {
        console.log('socket-error', error)
      })
    },
    // 2.3 断开连接
    disconnect () {
      if (this.socketTimer) {
        clearInterval(this.socketTimer)
        this.socketTimer = null
      }
      if (this.stompClient) {
        try {
          this.stompClient.disconnect()
          this.stompClient = null
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
